export default __webpack_public_path__ + "static/media/Limpieza General.5fdb7b08.png";